




































































































































































































































































































































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {Vue, Component} from 'vue-property-decorator';
import axios from 'axios';
import {Ax} from "@/utils";
import VueElementLoading from "vue-element-loading";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {BootstrapVueIcons} from 'bootstrap-vue';
import i18n from "../../../../services/i18n";

Vue.use(BootstrapVueIcons);
@Component({
    computed: {
        i18n() {
            return i18n
        }
    },
    components: {
        'loading': VueElementLoading,
        'treeselect': Treeselect
    },
    filters: {
        formatDate(value: any) {
            if (value) {
                const date = new Date(value*1000);
                return date.toLocaleDateString();
            }
            return null;
        }
    }
})
export default class ApplcationForm9 extends Vue {
    private cutness: any = null;
    private reg: any = null;
    private date_to: any = null;
    private user_id: any = '';
    private period: any = null;
    private convert: any = 1000;
    private loading: boolean = false;

    private showAbpInfo: boolean = false; //модальное информанионное окно
    private infoAbp:any = {}

    private funcDict: any = {};
    private spfDict: any = {};
    private currProgData: any[] = [];
    private currProgTreeData: any[] = [];
    private devProgData: any[] = [];
    private devProgTreeData: any[] = [];

    private reasonsFull:any[] = [];
    private reasonsDictOB:any[] = [];
    private get reasonsUOB():any[] {
        return this.createReasonsTree(1, 1)
    }
    private get reasonsEOB():any[] {
        return this.createReasonsTree(2, 1)
    }
    private reasonsDictPL:any[] = [];
    private get reasonsUPL():any[] {
        return this.createReasonsTree(1, 2)
    }
    private get reasonsEPL():any[] {
        return this.createReasonsTree(2, 2)
    }
    private dictReasons:any = {};
    private spfTable:any = [];

    private userNames:any = {};
    private isReasonEditable(pprNode:any, id:number) {
        for (const spf of this.spfTable) {
            if (spf.reason_id === id) {
                if (pprNode.spf_list.includes(spf.spf)) {
                    return true;
                }
            }
        }
        return false
    }

    private spfIN18:number[] = [111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 124, 131, 135];
    private spfIN19:number[] = [161, 162];
    private get totalTreeCollumn() {
        if (this.cutness.code === 0) return 3
        if (this.cutness.code === 1) return 4
    }
    private numValues:string[] = [
        'plg',
        'obaz',
        'plat',
        'registrob',
        'sum_discarded_oblig',
        'sumrg',
        'execution_rate',
        'expectation',
        'execution_expectation_rate',
        'sum_not_executed_expec',
        'sum_not_executed_payment',
        'sum_econ',
        'savings_gz',
        'savings_fot',
        'savings_etc',
        'rez_gov',
        'sum_unspent',
        'nd_ob',
        'nd_contests',
        'nd_abp',
        'nd_etc',
        'note_pl_reasonid',
        'note_ob_reasonid'
    ]
    private column_names:any = {
        'abp': {
            ru: 'АБП',
            kk: 'ББӘ'
        },
        'prg': {
            ru: 'Программа',
            kk: 'Бағдарлама'
        },
        'ppr': {
            ru: 'Подпрограмма',
            kk: 'Кіші бағдарлама'
        },
        'spf': {
            ru: 'Специфика',
            kk: 'Ерекшелік'
        },
        'plg': {
            ru: 'Сводный план финансирования на год',
            kk: 'Бір жылға арналған жиынтық қаржыландыру жоспары'
        },
        'obaz': {
            ru: 'по обязательствам',
            kk: 'міндеттемелер бойынша'
        },
        'plat': {
            ru: 'по платежам',
            kk: 'төлемдер бойынша'
        },
        'registrob': {
            ru: 'Принятые обязательства',
            kk: 'төлемдер бойынша'
        },
        'sum_discarded_oblig': {
            ru: 'Сумма непринятых обязательств (графа 8- графа 6)',
            kk: 'Қабылданбаған міндеттемелер сомасы (8-бағ. - 6-бағ.)'
        },
        'sumrg': {
            ru: 'Оплаченные обязательства',
            kk: 'Төленген міндеттемелер'
        },
        'execution_rate': {
            ru: '% исполнения (графа 10 / графа\\n7)х100',
            kk: 'Атқарылу % (10 - бағ./7 - бағ.*100)'
        },
        'expectation': {
            ru: 'Ожидаемое исполнение на год',
            kk: 'Бір жылға арналған күтілетін орындалуы'
        },
        'execution_expectation_rate': {
            ru: '% ожидаемого исполнения (графа 12 / графа\\n5)х100',
            kk: 'Күтіліп отырған атқарылу % (12 - бағ./5 -бағ.*100)'
        },
        'sum_not_executed_expec': {
            ru: 'Ожидаемая сумма неисполнения на год (графа 12 - графа 5)',
            kk: 'Бір жылға күтілетін атқарылмау сомасы(12-бағ. - 5-бағ.)'
        },
        'sum_not_executed_payment': {
            ru: 'Неисполнение плана по платежам (графа 10 - графа 7)',
            kk: 'Төлемдер бойынша атқарылмау сомасы (10-бағ. - 7-бағ.)'
        },
        'sum_econ': {
            ru: 'Экономия бюджетных средств за отчетный период – всего (графа 17+ графа 18+ графа 19)',
            kk: 'Есепті кезеңдегі бюджеттік қаражатты үнемдеу - барлығы (17 б.+18 б.+19 б.)'
        },
        'savings_gz': {
            ru: 'экономия по результатам гос. закупок',
            kk: 'мемлекеттік сатып алу нәтижелері бойынша үнемдеу'
        },
        'savings_fot': {
            ru: 'экономия по ФОТ',
            kk: 'ЕТҚ бойынша үнемдеу'
        },
        'savings_etc': {
            ru: 'прочая экономия',
            kk: 'басқа да үнемдеулер'
        },
        'rez_gov': {
            ru: 'Нераспределенный остаток резерва Правительства/ МИО',
            kk: 'Үкімет қорының бөлінбеген қалдығы'
        },
        'sum_unspent': {
            ru: 'Неосвоение за отчетный период (графа 15 - графа 16 - графа 20)',
            kk: 'Есептілік кезеңіндегі игерілмеу сомасы (15 б.-16 б.-20 б.)'
        },
        'nd_ob': {
            ru: 'невыполненные договорные обязательства поставщиков товаров (работ, услуг)',
            kk: 'тауарларды (жұмыстарды, көрсетілетін, қызметтерді) жеткізушілердің орындамаған шарттық '
        },
        'nd_contests': {
            ru: 'несостоявшиеся конкурсы по государственным закупкам',
            kk: 'мемлекеттік сатып алу бойынша өтпей қалған конкурстар'
        },
        'nd_abp': {
            ru: 'Управление бюджетной программой АБП',
            kk: 'ББӘ бюджеттік бағдарламаны тиімді басқармауы'
        },
        'nd_etc': {
            ru: 'прочие причины',
            kk: 'басқа да себептер'
        },
        'note_pl_reasonid': {
            ru: 'Примечание (обоснование АБП причин неосвоения за отчетный период)',
            kk: 'Ескерту (міндеттемелер бойынша жоспардың орындалмау себептерін ББӘ негіздеуі)\n'
        },
        'note_ob_reasonid': {
            ru: 'Примечание (обоснование АБП причин несвоевременного принятия либо непринятия обязательств)',
            kk: 'Ескерту (төлемдер бойынша жоспардың орындалмау себептерін ББӘ негіздеуі)'
        },
        'cur_prog': {
            ru: 'Текущие программы',
            kk: 'Ағымдағы бағдарламалар'
        },
        'dev_prog': {
            ru: 'Программы развития',
            kk: 'Даму бағдарламалары'
        },
        'overall': {
            ru: 'Всего',
            kk: 'Барлығы'
        },
        'save': {
            ru: 'Сохранить',
            kk: 'Сақтау'
        },
        'download': {
            ru: 'Скачать',
            kk: 'Жүктеу'
        },
        'refresh': {
            ru: 'Обновить',
            kk: 'Жаңарту'
        },
        'info': {
            ru: 'Информация',
            kk: 'Ақпарат'
        },
        'close': {
            ru: 'Закрыть',
            kk: 'Жабу'
        },
        'user': {
            ru: 'Пользователь',
            kk: 'Пайдаланушы'
        },
        'not_saved': {
            ru: 'Не сохранено',
            kk: 'Сақталмаған'
        },
        'data_saved': {
            ru: 'Данные сохранены',
            kk: 'Деректер сақталды'
        },
        'data_refreshed': {
            ru: 'Данные обновлены',
            kk: 'Деректер жаңартылды'
        },
        'reasons_econ': {
            ru: 'Причины экономии',
            kk: 'үнемдеу себептері'
        },
        'reasons_undev': {
            ru: 'Причины неосвоения',
            kk: 'игерілмеу себептері'
        },

        'warn_plat': {
            ru: 'Внимание! Сумма экономии и неосвоения по платежам не равна сумме неисполнения (графа 15)',
            kk: 'Назар аударыңыз! Төлемдер бойынша үнемдеу және игерілмеу сомасы орындамау сомасына тең емес (15-баған)'
        },
        'warn_obaz': {
            ru: 'Внимание! Сумма экономии и неосвоения по обязательствам не равна сумме неисполнения (графа 9)',
            kk: ' Назар аударыңыз! Міндеттемелер бойынша үнемдеу және игерілмеу сомасы орындамау сомасына тең емес (9-баған)'
        },
        'data_processed': {
            ru: 'отработано',
            kk: 'пысықталды'
        },
        'data_not_processed': {
            ru: 'не отработано',
            kk: 'пысықталмады'
        },
        'modal_abp_info': {
            infoAbp: {abp: null},
            get ru() {
                return `Информация по ${this.infoAbp.abp} абп`;
            },
            get kk() {
                return `${this.infoAbp.abp} ББӘ бойынша ақпарат`;
            }
        },
        'app9': {
            ru: 'приложение 9',
            kk: '9 қосымша'
        },
        'app9_analysis': {
            ru: 'Аналитический отчёт',
            kk: 'Талдамалы есептемесі'
        },
        'app9_reason_info': {
            ru: 'Информация о причинах ',
            kk: 'Себептер туралы ақпарат'
        },
        'app9_analysis_wide': {
            ru: 'Аналит. отчёт (расширенный)',
            kk: 'Талдамалы есептемесі (кеңейтілген)'
        },
        'data_converge': {
            ru: 'Данные сходятся',
            kk: 'Деректер сәйкес келеді'
        }
    }
    private inputFields:string[] = [
        // 'plg',
        // 'obaz',
        // 'plat',
        // 'registrob',
        // 'sum_discarded_oblig',
        // 'sumrg',
        // 'execution_rate',
        'expectation',
        // 'execution_expectation_rate',
        // 'sum_not_executed_expec',
        // 'sum_not_executed_payment',
        // 'sum_econ',
        // 'savings_gz',
        // 'savings_fot',
        // 'savings_etc',
        // 'rez_gov',
        // 'sum_unspent',
        // 'nd_ob',
        // 'nd_contests',
        // 'nd_abp',
        // 'nd_etc',
        // 'note_pl_reasonid',
        // 'note_ob_reasonid'
    ]
    private totalSum:any = {}
    async created() {
        this.$on('reportApplication9', (region: any, date_to: any, cutness: any, uuid: string, period:any, convert:any) => {
            this.currProgData = [];
            this.devProgData = [];
            this.currProgTreeData = [];
            this.devProgTreeData = [];
            this.date_to = null;
            this.cutness = null;
            this.reg = null;
            this.user_id = '';
            const conv:any = {'тыс. теңге': 1000, 'теңге': 1}
            this.convert = conv[convert]
            this.loadData(date_to, region, cutness, uuid);
            this.date_to = date_to;
            this.cutness = cutness;
            this.reg = region;
            this.user_id = uuid
            this.period = period
        });
        const that = this;
        const sumFields:any[] = [
            'plg',
            'obaz',
            'plat',
            'registrob',
            // 'sum_discarded_oblig',
            'sumrg',
            // 'execution_rate',
            'expectation',
            // 'execution_expectation_rate',
            // 'sum_not_executed_expec',
            // 'sum_not_executed_payment',
            // 'sum_econ',
            'savings_gz',
            'savings_fot',
            'savings_etc',
            'rez_gov',
            // 'sum_unspent',
            'nd_ob',
            'nd_contests',
            'nd_abp',
            'nd_etc'
        ]
        const item = that.totalSum
        for (const val of sumFields) {
            Object.defineProperty(item, val, {
                get: function () {
                    return that.total(`${val}`)
                },
                set: function (value) {
                    item[`_${val}`] = value;
                }
            })
        }
        Object.defineProperty(item, 'sum_discarded_oblig', {
            get: function () {
                return that.total('sum_discarded_oblig')
            }
        })
        Object.defineProperty(item, 'execution_rate', {
            get: function () {
                if (item.plat === 0) return 0
                return parseFloat((item.sumrg / item.plat * 100).toFixed(2))
            }
        })
        Object.defineProperty(item, 'execution_expectation_rate', {
            get: function () {
                if (item.plg === 0) return 0
                return parseFloat((item.expectation / item.plg * 100).toFixed(2))
            }
        })
        Object.defineProperty(item, 'sum_not_executed_expec', {
            get: function () {
                return that.total('sum_not_executed_expec')
            }
        })
        Object.defineProperty(item, 'sum_not_executed_payment', {
            get: function () {
                return that.total('sum_not_executed_payment')
            }
        })
        Object.defineProperty(item, 'sum_econ', {
            get: function () {
                return that.total('sum_econ')
            }
        })
        Object.defineProperty(item, 'sum_unspent', {
            get: function () {
                return that.total('sum_unspent')
            }
        })
        await this.loadReasons()
        await this.loadSPFTable()
    }

    private formatedDate(date_to: Date) {
        return `${date_to.getFullYear()}-${date_to.getMonth() + 1}-${date_to.getDate()}`
    }

    private async  getData(date_to: Date, region: any, cutness: any, uuid: string, abp:number|null = null, isUdate:boolean = false) {
        let treeS:any = {
            currTree: [],
            devTree: [],
            funcDict: {},
            spfDict: {}
        };
        const formatedDate = `${date_to.getFullYear()}-${date_to.getMonth() + 1}-${date_to.getDate()}`
        const request = {
            'cutness': 1, // cutness.code, для того чтобы видеть все спф и их суммы
            'region': region.code,
            'repdate': formatedDate,
            'user_id': uuid,
            'abp': abp,
            'is_update': isUdate,
            'convert': this.convert
        }
        await axios.post('/api-py/fulfillment-report/app-9/data', request).then(resp => {
            if (resp.status === 200) {
                treeS = resp.data;
            }
        }).catch(error => {
        })
        return treeS
    }

    private async loadUsernames() {
        for (const u in this.userNames) {
            try {
                await axios.get(`/api-py/get-realm-user/${u}`).then(resp => {
                    if (resp.status === 200) {
                        this.userNames[u] = resp.data.firstName + ' ' + resp.data.lastName
                    }

                })
            } catch (e) {

            }
        }
    }
    private user_name(uuid:string) {
        if (uuid in this.userNames) {
            return this.userNames[uuid]
        }
        return ''
    }


    private async loadData(date_to: Date, region: any, cutness: any, uuid: string, abp:number|null = null) {
        this.loading = true
        const that = this
        try {
            const treeS:any = await this.getData(date_to, region, cutness, uuid, abp)
            this.collapse = true;
            this.currProgData = treeS.currTree
            this.devProgData = treeS.devTree
            this.funcDict = treeS.funcDict
            this.spfDict = treeS.spfDict

            that.currProgTreeData = that.createTree(that.currProgData, this.funcDict, this.spfDict)
            that.devProgTreeData = that.createTree(that.devProgData, this.funcDict, this.spfDict)
            that.loading = false
            this.loadUsernames()
        } catch (e) {
            console.log(e)
            that.loading = false
        }
    }

    private async updateData(abpEll:any, isUpdate: boolean = false) {
        const updateValues:string[] = ['plg', 'obaz', 'plat', 'registrob', 'sumrg', 'expectation', 'savings_gz', 'savings_fot', 'savings_etc', 'rez_gov', 'nd_ob', 'nd_contests', 'nd_abp', 'nd_etc', 'note_pl_reasonid', 'note_ob_reasonid', 'status', 'update_date', 'user_id']

        const treeS:any = await this.getData(this.date_to, this.reg, this.cutness, this.user_id, abpEll.abp, isUpdate)
        const currTree = treeS.currTree
        const devTree = treeS.devTree
        for (const el of currTree) {
            if (!(el.user_id in this.userNames && el.user_id)) {
                this.userNames[el.user_id] = ''
            }
            const abpNode:any = this.currProgTreeData.find((v:any) => v.abp === el.abp)
            const prgNode:any = abpNode.child_list.find((v:any) => v.prg === el.prg)
            const pprNode:any = prgNode.child_list.find((v:any) => v.ppr === el.ppr)
            for (const v of updateValues) {
                pprNode[v] = el[v]
                if (!['note_pl_reasonid', 'note_ob_reasonid'].includes(v)) this.chgValue(pprNode, v, pprNode.develop_type)
            }
            for (const v of updateValues.slice(-2)) {
                abpNode[v] = pprNode[v]
            }
            pprNode._note_pl_reasonid_eco = this.reasonsFull.filter((v:any) => v.id in pprNode.note_pl_reasonid && (v.type === 2 || v.type === 3)).map((x:any) => `${x.gr_pl_id}_${x.id}`)
            pprNode._note_ob_reasonid_eco = this.reasonsFull.filter((v:any) => v.id in pprNode.note_ob_reasonid && (v.type === 2 || v.type === 3)).map((x:any) => `${x.gr_ob_id}_${x.id}`)
            pprNode._note_pl_reasonid_und = this.reasonsFull.filter((v:any) => v.id in pprNode.note_pl_reasonid && (v.type === 1 || v.type === 3)).map((x:any) => `${x.gr_pl_id}_${x.id}`)
            pprNode._note_ob_reasonid_und = this.reasonsFull.filter((v:any) => v.id in pprNode.note_ob_reasonid && (v.type === 1 || v.type === 3)).map((x:any) => `${x.gr_ob_id}_${x.id}`)
            this.chgValue(pprNode, 'note_pl_reasonid', pprNode.develop_type)
            this.chgValue(pprNode, 'note_ob_reasonid', pprNode.develop_type)

        }
        for (const el of devTree) {
            const abpNode:any = this.devProgTreeData.find((v:any) => v.abp === el.abp)
            const prgNode:any = abpNode.child_list.find((v:any) => v.prg === el.prg)
            const pprNode:any = prgNode.child_list.find((v:any) => v.ppr === el.ppr)
            for (const v of updateValues) {
                pprNode[v] = el[v]
                if (!['note_pl_reasonid', 'note_ob_reasonid'].includes(v)) this.chgValue(pprNode, v, pprNode.develop_type)
            }
            for (const v of updateValues.slice(-2)) {
                abpNode[v] = pprNode[v]
            }
            pprNode._note_pl_reasonid_eco = this.reasonsFull.filter((v:any) => v.id in pprNode.note_pl_reasonid && (v.type === 2 || v.type === 3)).map((x:any) => `${x.gr_pl_id}_${x.id}`)
            pprNode._note_ob_reasonid_eco = this.reasonsFull.filter((v:any) => v.id in pprNode.note_ob_reasonid && (v.type === 2 || v.type === 3)).map((x:any) => `${x.gr_ob_id}_${x.id}`)
            pprNode._note_pl_reasonid_und = this.reasonsFull.filter((v:any) => v.id in pprNode.note_pl_reasonid && (v.type === 1 || v.type === 3)).map((x:any) => `${x.gr_pl_id}_${x.id}`)
            pprNode._note_ob_reasonid_und = this.reasonsFull.filter((v:any) => v.id in pprNode.note_ob_reasonid && (v.type === 1 || v.type === 3)).map((x:any) => `${x.gr_ob_id}_${x.id}`)
            this.chgValue(pprNode, 'note_pl_reasonid', pprNode.develop_type)
            this.chgValue(pprNode, 'note_ob_reasonid', pprNode.develop_type)

        }
        if (isUpdate) this.makeToast('info', this.$t('modules.common.update'), this.$t('modules.common.data_updated'));
    }

    private async saveData(abpEll:any=null) {
        let dataSet:any[] = []
        let flkExist = false
        let flk1 = false;
        let flk2 = false;
        if (!abpEll) {
            dataSet = this.currProgData.concat(this.devProgData).filter((v:any) => v.data_type === 4)
        } else {
            for (const el of abpEll.develop_type? this.devProgData : this.currProgData) {
                if (el.abp === abpEll.abp && el.data_type === 4) {
                    if (!flk1) {
                        flk1 = this.flk1(el);
                    }
                    if (!flk2) {
                        flk2 = this.flk2(el);
                    }
                    if (!flkExist) {
                        flkExist = flk1 || flk2
                    }
                    dataSet.push(el)
                }
            }
        }
        if (flkExist) {
            if (flk1) {
                this.makeToast('danger', this.$t('modules.common.error'),   this.$t('modules.budget_execution_monitoring.reports.app_9.warn_obaz'))
            }
            if (flk2) {
                this.makeToast('danger', this.$t('modules.common.error'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_plat'))
            }
        }
        const req = {
            save_list: dataSet,
            repdate: this.formatedDate(this.date_to),
            region: this.reg.code,
            user_id: this.user_id
        }
        await axios.post('/api-py/fulfillment-report/app-9/data/save', req).then(resp => {
            if (resp.status === 200) {
                this.makeToast('success', this.$t('modules.common.saving'), this.$t('modules.common.data_saved_successfully'))
                this.updateData(abpEll)
            }
        })
    }
    private collapse: boolean = true;

    private clkCollapseAll(data: any, collapse = true) {
        this.$set(data, 'collapse', collapse);
        if ('child_list' in data && data.child_list && data.child_list.length) {
            for (const el of data.child_list) {
                this.clkCollapseAll(el, collapse)
            }
        }
    }

    private clkCollapse(abp: any = null, prg: any = null, ppr: any = null, spf: any = null, collapse: boolean = false, dev_type = 0) {
        if (abp !== null) {
            let obj = !dev_type ? this.currProgTreeData[abp] : this.devProgTreeData[abp]
            if (prg !== null) {
                obj = obj.child_list[prg]
            }
            if (ppr !== null) {
                obj = obj.child_list[ppr]
            }
            if (collapse) {
                this.clkCollapseAll(obj, collapse)
            }
            this.$set(obj, 'collapse', collapse);
        } else {
            this.collapse = collapse;
            for (const el of this.currProgTreeData) {
                this.clkCollapseAll(el, collapse)
            }
            for (const el of this.devProgTreeData) {
                this.clkCollapseAll(el, collapse)
            }

        }
    }
    private total(field: string) {
        let sum = 0
        for (const el of this.currProgTreeData.concat(this.devProgTreeData)) {
            sum += el[field]
        }
        return sum
    }
    private downloadRep(rep_type:number = 4) {
        // this.loading = true
        const formatedDate = `${this.date_to.getFullYear()}-${this.date_to.getMonth() + 1}-${this.date_to.getDate()}`
        const request = {
            'cutness': 0,
            'region': this.reg.code,
            'repdate': formatedDate,
            'user_id': this.user_id,
            'abp': null,
            'is_update': false,
            'period': this.period,
            'locale': this.$i18n.locale,
            'convert': this.convert
        }
        const that = this
        try {
            this.makeToast('info', this.$t('modules.common.attention'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_download'));
            Ax(
                {
                    url: `/api-py/fulfillment-report/app-9/report/${rep_type}`,
                    method: 'POST',
                    responseType: 'blob',
                    data: request
                },
                (data: any) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9')
                    if (rep_type === 1) name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9_analysis')
                    if (rep_type === 2) name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9_reason_info')
                    if (rep_type === 3) name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9_analysis_wide')
                    if (rep_type === 8) name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9_form_8')
                    if (rep_type === 9) name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9_form_9')
                    link.setAttribute('download', name + '.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    that.loading = false
                },
                (error) => {
                    that.loading = false
                    this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                }
            );
        } catch (error) {
            that.loading = false
            this.makeToast('danger', this.$t('modules.common.warning'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_filter'));
        }
    }

    private createReasonsTree(type:any = null, obaz_plat:any = 1) {
        const dict_ob:any = {}
        const dict_pl:any = {}
        for (const r of this.reasonsFull) {
            if (type !== null) {
                if (r.type !== type && r.type !== 3) {
                    continue
                }
            }
            if (!dict_ob[r.gr_ob_id]) {
                dict_ob[r.gr_ob_id] = {
                    id: r.gr_ob_id.toString(),
                    label: r[`gr_ob_name_${this.$i18n.locale}`],
                    children: [],
                    value: Object.assign({}, r)
                }
            }
            if (!dict_pl[r.gr_pl_id]) {
                dict_pl[r.gr_pl_id] = {
                    id: r.gr_pl_id.toString(),
                    label: r[`gr_pl_name_${this.$i18n.locale}`],
                    children: [],
                    value: Object.assign({}, r)
                }
            }
            dict_ob[r.gr_ob_id].children.push({
                id: `${r.gr_ob_id}_${r.id}`,
                label: r[`name_${this.$i18n.locale}`],
                value: Object.assign({}, r)
            })
            dict_pl[r.gr_pl_id].children.push({
                id: `${r.gr_pl_id}_${r.id}`,
                label: r[`name_${this.$i18n.locale}`],
                value: Object.assign({}, r)
          })

        }
        if (obaz_plat === 1) return Object.values(dict_ob)
        else return Object.values(dict_pl)
    }
    private async loadReasons() {
        await axios.get('/api-py/fulfillment-application-reasons').then(resp => {
            if (resp.status === 200) {
                const dictsList:any = resp.data[0];
                const grDicts:any = resp.data[1];
                for (const d of dictsList) {
                    d.gr_ob_name_ru = grDicts[d.gr_ob_id].name_ru
                    d.gr_ob_name_kk = grDicts[d.gr_ob_id].name_kk
                    d.gr_ob_name_en = grDicts[d.gr_ob_id].name_en
                    d.gr_pl_name_ru = grDicts[d.gr_pl_id].name_ru
                    d.gr_pl_name_kk = grDicts[d.gr_pl_id].name_kk
                    d.gr_pl_name_en = grDicts[d.gr_pl_id].name_en
                }
                this.reasonsFull = dictsList
                for (const r of dictsList) {
                    this.dictReasons[r.id] = r
                }
                this.reasonsDictPL = this.createReasonsTree(null, 2)
                this.reasonsDictOB = this.createReasonsTree(null, 1)
            }
        })
    }

    private async loadSPFTable() {
        await axios.get('/api-py/fulfillment-report/app-9/spf-table').then(resp => {
            if (resp.status === 200) {
                this.spfTable = resp.data
            }
        })
    }

    private reasonText(id:number) {
        const it = this.reasonsFull.find((v:any) => v.id === id)
        const l_name = `name_${this.$i18n.locale}`
        if (it) return it[l_name]
        else return 1
    }
    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
    private reSum(item:any, field:string) {
        let sum = 0;
        if (field[0] === '_') {
            field = field.replace('_', '');
        }
        for (const ch1 of item.child_list) {
            sum += ch1[field]
        }
        return sum

    }
    private sumReasons(item:any, field:string, is_ppr:boolean = false) {
        let child_reasons:any[] = []
        child_reasons = item[field].map((v: any) => v.id)

        return [...new Set(child_reasons)]
    }

    private calcFields(item:any, sum:boolean = true) {
        const that = this;
        const sumFields:any[] = [
            'plg',
            'obaz',
            'plat',
            'registrob',
            // 'sum_discarded_oblig',
            'sumrg',
            // 'execution_rate',
            'expectation',
            // 'execution_expectation_rate',
            // 'sum_not_executed_expec',
            // 'sum_not_executed_payment',
            // 'sum_econ',
            'savings_gz',
            'savings_fot',
            'savings_etc',
            'rez_gov',
            // 'sum_unspent',
            'nd_ob',
            'nd_contests',
            'nd_abp',
            'nd_etc'
        ]
        if (sum) {
            for (const val of sumFields) {
                Object.defineProperty(item, val, {
                    get: function () {
                        return that.reSum(item, `_${val}`)
                    },
                    set: function (value) {
                        item[`_${val}`] = value;
                    }
                })
            }
            Object.defineProperty(item, 'status', {
                get: function () {
                    for (const ch of item.child_list) {
                        if (!ch.status) return false;
                    }
                    return true;
                },
                set: function (value) {
                    for (const ch of item.child_list) {
                        ch.status = value
                    }
                }
            })
            Object.defineProperty(item, 'flk1', {
                get: function () {
                    for (const ch of item.child_list) {
                        if (ch.flk1) return true;
                    }
                    return false;
                }
            })
            Object.defineProperty(item, 'flk2', {
                get: function () {
                    for (const ch of item.child_list) {
                        if (ch.flk2) return true;
                    }
                    return false;
                }
            })

        } else {
            const sumR:string[] = ['savings_gz', 'savings_fot', 'savings_etc', 'rez_gov', 'nd_ob', 'nd_contests', 'nd_abp', 'nd_etc']
            for (let i = 1; i < 10; i++) {
                const f = sumR[i-1]
                Object.defineProperty(item, f, {
                    get: function () {
                        let sum = 0
                        for (const r_id in item.note_pl_reasonid) {
                            const reason = that.dictReasons[r_id]
                            if (reason.gr_pl_id === i) {
                                sum += item.note_pl_reasonid[r_id]
                            }
                        }
                        return sum
                    }
                });
            }
            Object.defineProperty(item, 'flk1', {
                get: function () {
                    return that.flk1(item)
                }
            })
            Object.defineProperty(item, 'flk2', {
                get: function () {
                    return that.flk2(item)
                }
            })
            Object.defineProperty(item, 'status', {
                get: function () {
                    return item._status
                },
                set: function (value) {
                    item._status = value
                    that.chgValue(item, 'status', item.develop_type)
                }
            })
        }
        Object.defineProperty(item, 'sum_discarded_oblig', {
            get: function () {
                return item.registrob - item.obaz
            }
        })
        Object.defineProperty(item, 'execution_rate', {
            get: function () {
                if (item.plat === 0) return 0
                return parseFloat((item.sumrg / item.plat * 100).toFixed(2))
            }
        })
        Object.defineProperty(item, 'execution_expectation_rate', {
            get: function () {
                if (item.plg === 0) return 0
                return parseFloat((item.expectation / item.plg * 100).toFixed(2))
            }
        })
        Object.defineProperty(item, 'sum_not_executed_expec', {
            get: function () {
                return item.expectation - item.plg
            }
        })
        Object.defineProperty(item, 'sum_not_executed_payment', {
            get: function () {
                return item.sumrg - item.plat
            }
        })
        Object.defineProperty(item, 'sum_econ', {
            get: function () {
                return item.savings_gz + item.savings_fot + item.savings_etc
            }
        })
        Object.defineProperty(item, 'sum_unspent', {
            get: function () {
                return item.sumrg - item.plat - item.sum_econ - item.rez_gov
            }
        })



    }
    private createTree(tableData: any[], funcDict:any, spfDict:any) {

        const tree:any = {}
        for (const [idx, item] of tableData.entries()) {
            if (!(item.user_id in this.userNames && item.user_id) && item.update_date) this.userNames[item.user_id] = '';

            const newItem = Object.assign({idx: idx, collapse: this.collapse}, item)
            const dev_type = newItem.develop_type
            const abp:number = newItem.abp
            const prg:number = newItem.prg
            const ppr:number = newItem.ppr
            let abpNode:any = tree[abp]
            if (!abpNode) {
                abpNode = Object.assign({idx: idx, collapse: this.collapse, child_list: [], flk_rows: []}, newItem)
                delete abpNode.spf_list
                this.calcFields(abpNode)
                tree[abp] = abpNode
            }
            let prgNode = abpNode.child_list.find((x:any) => x.prg === prg)
            if (!prgNode) {
                prgNode = Object.assign({idx: idx, collapse: this.collapse, child_list: []}, newItem)
                delete prgNode.spf_list
                this.calcFields(prgNode)
                abpNode.child_list.push(prgNode)
            }
            let pprNode = prgNode.child_list.find((x:any) => x.ppr === ppr)
            if (!pprNode) {
                '_note_pl_reasonid_eco'
                '_note_ob_reasonid_eco'
                '_note_pl_reasonid_und'
                '_note_ob_reasonid_und'

                pprNode = Object.assign({idx: idx, collapse: this.collapse, child_list: []}, newItem)
                pprNode._note_pl_reasonid_eco = this.reasonsFull.filter((v:any) => v.id in pprNode.note_pl_reasonid && (v.type === 2 || v.type === 3)).map((x:any) => `${x.gr_pl_id}_${x.id}`)
                pprNode._note_ob_reasonid_eco = this.reasonsFull.filter((v:any) => v.id in pprNode.note_ob_reasonid && (v.type === 2 || v.type === 3)).map((x:any) => `${x.gr_ob_id}_${x.id}`)
                pprNode._note_pl_reasonid_und = this.reasonsFull.filter((v:any) => v.id in pprNode.note_pl_reasonid && (v.type === 1 || v.type === 3)).map((x:any) => `${x.gr_pl_id}_${x.id}`)
                pprNode._note_ob_reasonid_und = this.reasonsFull.filter((v:any) => v.id in pprNode.note_ob_reasonid && (v.type === 1 || v.type === 3)).map((x:any) => `${x.gr_ob_id}_${x.id}`)
                tableData[idx].data_type = 4
                pprNode.child_list = pprNode.spf_list
                pprNode._status = pprNode.status
                pprNode.spf_list = []
                this.calcFields(pprNode, false)
                prgNode.child_list.push(pprNode)
            } else {
                for (const v of ['plg', 'obaz', 'plat', 'registrob', 'sumrg']) {
                    pprNode[v] += newItem[v]
                }
            }
            if (funcDict) {
                if (abp in funcDict) {
                    if (!abpNode.name_ru && funcDict[abp] && funcDict[abp].name_ru) {
                        abpNode.name_ru = funcDict[abp].name_ru;
                        abpNode.name_kk = funcDict[abp].name_kk;
                    }
                    if (funcDict[abp] && funcDict[abp].child_list && prg in funcDict[abp].child_list) {
                        if (!prgNode.name_ru && funcDict[abp].child_list[prg] && funcDict[abp].child_list[prg].name_ru) {
                            prgNode.name_ru = funcDict[abp].child_list[prg].name_ru;
                            prgNode.name_kk = funcDict[abp].child_list[prg].name_kk;
                        }
                        if (funcDict[abp].child_list[prg].child_list && ppr in funcDict[abp].child_list[prg].child_list) {
                            if (!pprNode.name_ru && funcDict[abp].child_list[prg].child_list[ppr] && funcDict[abp].child_list[prg].child_list[ppr].name_ru) {
                                pprNode.name_ru = funcDict[abp].child_list[prg].child_list[ppr].name_ru;
                                pprNode.name_kk = funcDict[abp].child_list[prg].child_list[ppr].name_kk;
                            }
                        }
                    }
                }
            }
            if (spfDict && this.cutness.code) {
                for (const spfNode of pprNode.child_list) {
                    if (spfNode.spf in spfDict) {
                        spfNode.name_ru = spfDict[spfNode.spf].name_ru;
                        spfNode.name_kk = spfDict[spfNode.spf].name_kk;
                    }
                    pprNode.spf_list.push(spfNode.spf)
                }

            }

        }
        return Object.values(tree)

    }


    private flk1(pprNode:any) {
        // flk graph 28 reasons_ob === graph 9 discarde
        let sum = 0
        for (const r in pprNode.note_ob_reasonid) {
            sum += pprNode.note_ob_reasonid[r];
        }
        return !(parseFloat((pprNode.registrob - pprNode.obaz).toFixed(2)) ===  parseFloat(sum.toFixed(2)))
    }
    private flk2(pprNode:any) {
        let sum = 0
        for (const r in pprNode.note_pl_reasonid) {
            sum += pprNode.note_pl_reasonid[r];
        }
        // flk graph 27 reasons_pl === graph 15 not_exec_paym
        return !(parseFloat((pprNode.sumrg - pprNode.plat).toFixed(2)) === parseFloat(sum.toFixed(2)))
    }

    private chgStatus(node:any) {
        if (node.data_type === 4) {

        }
        const flk1 = node.flk1;
        const flk2 = node.flk2;
        const errors = flk1 || flk2
        if (errors) {
            if (flk1) {
                this.makeToast('danger', this.$t('modules.common.error'),   this.$t('modules.budget_execution_monitoring.reports.app_9.warn_obaz'))
            }
            if (flk2) {
                this.makeToast('danger', this.$t('modules.common.error'),  this.$t('modules.budget_execution_monitoring.reports.app_9.warn_plat'))
            }
        }
        if (errors) {
            node.status = false
        }
        if (node.status) this.saveData(node)
    }

    private chgValue(pprObj: any, fieldName: any, dev_type: any, change_code: any = null) {
        if (['note_pl_reasonid', 'note_ob_reasonid'].includes(fieldName)) {
            const temp:any = {}
            let reasons_eco:any[] = []
            let reasons_und:any[] = []
            const take_key = fieldName === 'note_pl_reasonid'? 'pl': 'ob'
            const list_eco:string = pprObj[`_note_${take_key}_reasonid_eco`]
            const list_und:string = pprObj[`_note_${take_key}_reasonid_und`]
            for (const el of list_eco) {
              const spl = el.split('_').map((v:string) => parseInt(v))
              if (spl.length == 1) {
                const gr_id = spl[0]
                const tree = fieldName === 'note_pl_reasonid'? this.reasonsEPL: this.reasonsEOB
                const rs = tree.find((x:any) => x.id === gr_id.toString()).children.map((v:any) => v.id)
                reasons_eco = reasons_eco.concat(rs)
              } else {
                reasons_eco.push(el)
              }
            }
            for (const el of list_und) {
                const spl = el.split('_').map((v:string) => parseInt(v))
                if (spl.length == 1) {
                    const gr_id = spl[0]
                    const tree = fieldName === 'note_pl_reasonid'? this.reasonsUPL: this.reasonsUOB
                    const rs = tree.find((x:any) => x.id === gr_id.toString()).children.map((v:any) => v.id)
                    reasons_und = reasons_und.concat(rs)
                } else {
                    reasons_und.push(el)
                }
            }
            pprObj[`_note_${take_key}_reasonid_eco`] = reasons_eco
            pprObj[`_note_${take_key}_reasonid_und`] = reasons_und
            for (const el of reasons_eco.concat(reasons_und)) {
                const spl = el.split('_').map((v:string) => parseInt(v))
                const r_id = spl[1]
                if (this.dictReasons[r_id].type === 3) {
                    if (change_code !== null && [1, 2].includes(change_code)) {
                        if (change_code === 1) {
                            pprObj.r31 = true;
                            pprObj.r32 = false;
                        } else {
                            pprObj.r31 = false;
                            pprObj.r32 = true;
                        }
                    }
                }
                if (!(r_id in pprObj[fieldName])) {
                    temp[r_id] = 0
                    if (fieldName === 'note_pl_reasonid') {
                        let sum = 0;
                        for (const spf of this.spfTable) {
                            if (r_id === spf.reason_id) {
                                const spfNode = pprObj.child_list.find((v:any) => v.spf === spf.spf)
                                if (spfNode) {
                                    sum += spfNode.sumrg - spfNode.plat
                                }
                            }
                        }
                        if (sum) {
                            temp[r_id] = parseFloat(sum.toFixed(2))
                        }
                    }
                } else {
                    temp[r_id] = pprObj[fieldName][r_id]
                }
            }
            pprObj[fieldName] = temp
            for (const f of  ['savings_gz', 'savings_fot', 'savings_etc', 'rez_gov', 'nd_ob', 'nd_contests', 'nd_abp', 'nd_etc']) {
                this.chgValue(pprObj, f, dev_type)
            }

        }
        if (!dev_type) {
            this.currProgData[pprObj.idx][fieldName] = pprObj[fieldName];
            this.currProgData[pprObj.idx].changed = true;
        } else {
            this.devProgData[pprObj.idx][fieldName] = pprObj[fieldName];
            this.devProgData[pprObj.idx].changed = true;
        }

    }

    // ------

    private noAbc(evt: any) {
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
        if (!regex.test(key)) {
            evt.preventDefault();
            return false;
        }
    }

    private nextInput(event: any) {
        event.preventDefault();
        // Isolate the node that we're after
        const currentNode = event.target;
        // find all tab-able elements
        const allElements = document.querySelectorAll('input'); // area, object, select, [contenteditable]
        // Find the current tab index.
        const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el));
        if (!event.target.value) {
            event.target.value = 0;
        }
        // select/focus the following element
        const targetIndex = (currentIndex + 1) % allElements.length;
        if (targetIndex < allElements.length) {
            allElements[targetIndex].select();
        }
    }// enter работает как tab

    private getNextInputIndx(prgIdx: number, pprIdx: number, spfIndx: number, chldIndx: number | null) {
    }
    // ---------

    private inputFocus(event: any) {
        event.target.select();
    }

    private inputFixed(item: any, field: any, value: any, digit: any) {
        if (value) {
            this.$set(item, field, parseFloat(parseFloat(value).toFixed(digit)));
        } else {
            this.$set(item, field, 0);
        }
    }
}
